@if (value) {
  <mat-form-field class="sort-dropdown" data-testid="sort-dropdown">
    <mat-select
      (selectionChange)="onSelect($event.value)"
      [value]="value"
      disableOptionCentering
      [panelClass]="panelClass"
      >
      <mat-select-trigger>
        {{ 'Sort by: ' + value }}
      </mat-select-trigger>
      @for (option of options; track option) {
        <mat-option [value]="option">
          {{ option }}
        </mat-option>
      }
    </mat-select>
    <mat-icon (click)="clear($event)" class="sort-close" data-testid="sort-clear" matSuffix> close</mat-icon>
  </mat-form-field>
} @else {
  <div (click)="open($event)" class="sort-dropdown nosort" data-testid="sort-dropdown">
    <div class="label text-type-8">Sort:</div>
    <mat-icon>sync_alt</mat-icon>
    <mat-form-field class="sr-sort-hidden">
      <mat-select
        #sortSelect
        (selectionChange)="onSelect($event.value)"
        [value]="value"
        disableOptionCentering
        [panelClass]="panelClass"
        >
        @for (option of options; track option) {
          <mat-option [value]="option">
            {{ option }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
}
